// ---------------------------------------
// Array with drug ids
// ---------------------------------------
exports.predict = async function ( ids ) {

  const token = localStorage.getItem( "token" )

  const params = {
    method: "GET",
    headers: {
      // "content-type": "application/json"
      // Add Cors headers to route
      // "authorization": `Token ${token}`
    }
  }

  var api = "https://api.epha.io"

  if ( location.hostname == "epha.health" ) {
    api = "https://api.epha.health"
  }

  return fetch( encodeURI( `${api}/kinetic/predict/?id=${ids.join(",")}` ), params ).then( res => res.json() ).catch( err => ( {
    meta: { status: "Service unavailable", code: 503, message: err.message }
  } ) )

}